import request from '@/utils/request'

// 举报列表（默认只返回待处理）
export function getReportList(params) {
  return request({
    url: '/admin/reports/list',
    method: 'get',
    params
  })
}

// 举报详情
export function getReportDetail(id) {
  return request({
    url: `/admin/reports/${id}`,
    method: 'get'
  })
}

// 判定成立：内容转违规，并按需处罚作者
export function acceptReport(id, data) {
  return request({
    url: `/admin/reports/${id}/accept`,
    method: 'post',
    data
  })
}

// 驳回：内容没问题
export function rejectReport(id, data) {
  return request({
    url: `/admin/reports/${id}/reject`,
    method: 'post',
    data
  })
}
